import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Route } from 'src/app/models/enums/Route.enum';
import { Rule } from 'src/app/models/types/Rule/Rule.type';
import { SharedModule } from 'src/app/modules/shared.module';
import { RulesService } from 'src/app/services/api/rules.service';

@Component({
  selector: 'app-categories-page',
  imports: [SharedModule],
  templateUrl: './categories-page.component.html',
  styleUrl: './categories-page.component.scss'
})
export class CategoriesPageComponent {

  constructor(
    public readonly rulesService: RulesService,
    private readonly router: Router,
  ) { }

  /**
  * Consente di navigare alla pagina di categoria in base alla rule selezionata.
  */
  handleClick(rule: Rule): void {
    this.rulesService.setSelectedRule(rule);
    this.router.navigate([`/${Route.Main}/${Route.RulePage}/${this.rulesService.selectedRule()?.id}`]);
  }

}
